import * as React from 'react'
import * as moment from 'moment'
import 'moment/locale/fr'
import {BrowserRouter} from 'react-router-dom'
import {createStyles, Theme, WithStyles, withStyles} from '@material-ui/core'
import {Route, Switch} from 'react-router'
import {config} from 'src/conf/config'
import Empty from 'src/page/Empty/Empty'
import {withI18n, WithI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import {connect} from 'react-redux'
import {RootState} from 'src/core/redux/reducer'
import News from 'src/page/News/News'
import { UtilsAction } from 'src/core/redux/action/utilsAction'
import { fetchCategories } from 'src/core/redux/action/categoriesAction'
import ForgotPassword from 'src/page/ForgotPassword/ForgotPassword'
import Platform from 'src/Platform'
import IdleTimer from 'react-idle-timer'
import { Helmet } from 'react-helmet'
import { fetchAccountInfos } from 'src/core/redux/action/accountInfosAction'
import PublicNews from 'src/page/PublicNews/PublicNews'
import PublicProduct from 'src/page/PublicProduct/PublicProduct'
import PublicProductDetail from 'src/page/PublicProduct/PublicProductDetail'
import PublicNewsDetail from 'src/page/PublicNews/PublicNewsDetail'

const paddingTop = (t: Theme) => 0

const styles = (t: Theme) => createStyles({
  body: {
    color: t.palette.text.primary,
    background: t.palette.background.paper,
  },
  reactWpr: {
    paddingTop: paddingTop(t),
    position: 'absolute',
    top: '48px',
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'auto'
  }
});

const timoutIdle = 1000 * 60;
const intervalTime = 1000 * 60;

interface IProps extends WithStyles<typeof styles>,
  WithI18n,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
}

class App extends React.Component<IProps, {}> {

  private idleTimer: any;
  private request: any;

  componentDidMount(){
    this.props.fetchCategories();
    this.props.fetchMapNameCategories();
    this.props.fetchMapProductType();
    moment.locale('fr');
  }

  render() {
    const {classes, t} = this.props
    return (
      <>
        <Helmet titleTemplate={`${t.App_title_page_Main} - %s`} defaultTitle={t.App_title_page_Main} />
        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={timoutIdle} />
        <BrowserRouter basename={config.basePath}>
          <div className={`${classes.body} ${!this.isPublicSite() ? classes.reactWpr: ''}`}>
            <Switch>
              <Route exact path="/news" component={News} />
              <Route exact path="/news/:postId/:postName" component={PublicNewsDetail} />
              <Route exact path="/nos-actualites/:postId" component={PublicNewsDetail} />
              <Route exact path="/nos-actualites/:postId/:postName" component={PublicNewsDetail} />
              <Route exact path="/:publicNewsType/nos-actualites" component={PublicNews}/>
              <Route exact path="/:publicNewsType/nos-actualites/:postId/:postName" component={PublicNewsDetail} />
              <Route exact path="/public-product" component={PublicProduct}/>
              <Route exact path="/public-product/:productId" component={PublicProductDetail}/>
              <Route path="/forgot-password" component={ForgotPassword}/>
              <Route exact paths={["/","","/ptf"]} component={Platform}/>
              <Route component={Empty} />
            </Switch>
          </div>
        </BrowserRouter>
      </>
    )
  }

  isPublicSite = () => {
    return window.location.href.includes("/nos-actualites") 
          || window.location.href.includes("/public-product") 
          || window.location.href.includes("/nos-actualites") 
          || window.location.href.includes("/news")
  }
  
  // tslint:disable: no-empty
  onAction = (e) => {}

  onActive = (e) => {
    console.info('time remaining', this.idleTimer.getRemainingTime())
    clearInterval(this.request)
  }

  onIdle = (e) => {
    this.request = setInterval(()=> this.controlIdle(), intervalTime)
  }

  controlIdle = () => {
    if(window.location && window.location.href && !this.isPublicSite()){
      this.props.fetchInfos()
    } 
  }

  componentWillUnmount(){
    clearInterval(this.request)
  }

}

const state2props = (state: RootState) => ({
});

const dispatch2props = dispatch => ({
  fetchInfos: () => dispatch(fetchAccountInfos()),
  fetchMapNameCategories: () => dispatch(UtilsAction.initMapNameCategories()),
  fetchMapProductType: () => dispatch(UtilsAction.initMapProductType()),
  fetchCategories: () => dispatch(fetchCategories()),
});

export default compose(
  withI18n,
  connect(state2props, dispatch2props),
  withStyles(styles)
)(App)


// WEBPACK FOOTER //
// ./src/App.tsx